import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnChanges,
  Renderer2,
  SimpleChanges,
} from '@angular/core';

@Directive({
  selector: '[appDisableInteractions]',
})
export class DisableInteractionsDirective implements OnChanges {
  @Input() disableTextSelection = false;
  @Input() disableInteractions = false;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['disableTextSelection']) {
      this.updateTextSelection();
    }
    if (changes['disableInteractions']) {
      this.updateInteractions();
    }
  }

  private updateInteractions() {
    if (this.disableInteractions) {
      this.renderer.setAttribute(
        this.el.nativeElement,
        'onselectstart',
        'return false'
      );
      this.renderer.setAttribute(
        this.el.nativeElement,
        'onpaste',
        'return false'
      );
      this.renderer.setAttribute(
        this.el.nativeElement,
        'oncopy',
        'return false'
      );
      this.renderer.setAttribute(
        this.el.nativeElement,
        'oncut',
        'return false'
      );
      this.renderer.setAttribute(
        this.el.nativeElement,
        'ondrag',
        'return false'
      );
      this.renderer.setAttribute(
        this.el.nativeElement,
        'ondrop',
        'return false'
      );
      this.renderer.setAttribute(this.el.nativeElement, 'autocomplete', 'off');
    }
  }

  private updateTextSelection() {
    if (this.disableTextSelection) {
      this.renderer.setStyle(this.el.nativeElement, 'user-select', 'none');
    } else {
      this.renderer.removeStyle(this.el.nativeElement, 'user-select');
    }
  }

  private getValues(): boolean {
    return this.disableTextSelection && this.disableInteractions;
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (this.getValues()) {
      if (event.ctrlKey && event.key === 'a') {
        event.preventDefault();
      }
    }
  }

  @HostListener('document:keydown.shift.arrow', ['$event'])
  disableShiftArrowSelection(event: KeyboardEvent) {
    this.getValues() && event.preventDefault();
  }

  @HostListener('window:beforeprint', ['$event'])
  beforePrint(event: Event) {
    if (this.getValues()) {
      event.preventDefault();
      window.location.reload();
    }
  }

  @HostListener('window:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (this.getValues()) {
      if (event.ctrlKey && event.key === 'p') {
        event.preventDefault();
      }
    }
  }
}
